import { configureStore } from "@reduxjs/toolkit";
import authSlice from "./Services/Features/Auth/authSlice";
import branchSlice from "./Services/Features/Branch/branchSlice";
import categorySlice from "./Services/Features/Category/categorySlice";
import BannerSlice from "./Services/Features/Banner/bannerSlice";
import TreatmentSlice from "./Services/Features/Treatment/treatmentSlice";
import VoucherSlice from "./Services/Features/Voucher/voucherSlice";
import DoctorSlice from "./Services/Features/Doctor/doctorSlice";
import setupScheduleSlice from "./Services/Features/SetupSchedule/setupScheduleSlice";
import orderSlice from "./Services/Features/Order/orderSlice";
import userSlice from "./Services/Features/User/userSlice";
import productSlice from "./Services/Features/Product/productSlice";
import categoryProductSlice from "./Services/Features/CategoryProduct/categoryProductSlice";
import loyaltySlice from "./Services/Features/Loyalty/loyaltySlice";
import adminSlice from "./Services/Features/Admin/adminSlice";

const store = configureStore({
    reducer: {
        auth: authSlice,
        branch: branchSlice,
        category: categorySlice,
        banner: BannerSlice,
        treatment: TreatmentSlice,
        voucher: VoucherSlice,
        doctor: DoctorSlice,
        setupSchedule: setupScheduleSlice,
        order: orderSlice,
        user: userSlice,
        product: productSlice,
        categoryProduct: categoryProductSlice,
        loyalty: loyaltySlice,
        admin: adminSlice,
    },
});

export default store;